import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasIdCacheKeys: AllRouteEndpoints[] = [];
